import Dms from "@/modules/dms/common/service/Dms";
import Core from "@/modules/core/service/Core";

const state = {
    enums: null,
}

const mutations = {
    updateDmsEnums (state, payload) {
        state.enums  = payload;
    },

}

const actions = {
    initDmsEnums ( { commit }) {
        return Core.method.get(Dms.url.enums).then(data => {
            commit ('updateDmsEnums', data);
        })
    },
}

const getters = {
    dms: state => {
        return state.enums;
    },
}

const dmsModule = {
    state,
    mutations,
    actions,
    getters
}

export default dmsModule